import React from "react";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from "../components/ui/select";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "../components/ui/tooltip";

const ScenarioSelector = ({
  selectedScenario,
  setSelectedScenario,
  selectedMood,
  setSelectedMood,
  selectedDifficulty,
  setSelectedDifficulty,
  scenarios,
  moods,
  difficulties,
  tooltips,
  scenarioDescriptions,
  moodDescriptions,
}) => {
  return (
    <>
      {/* Dropdown Section */}
      <div className="flex flex-col md:flex-row w-full mb-1.5 2xl:mb-4 gap-1.5 md:gap-2 2xl:gap-4">
        {/* Scenario Selector */}
        <div className="flex flex-col w-full">
          <label className="text-xs md:text-sm font-medium text-gray-900 dark:text-white mb-1">
            Choose a Scenario
          </label>
          <Select onValueChange={setSelectedScenario}>
            <SelectTrigger className="bg-white/70 dark:bg-gray-800/70 text-gray-900 dark:text-gray-200 border border-gray-300/30 dark:border-orange-500/70 p-1.5 rounded-lg w-full backdrop-blur-sm hover:bg-orange-500 hover:text-white transition-colors text-xs md:text-sm">
              {selectedScenario}
            </SelectTrigger>
            <SelectContent className="bg-white dark:bg-neutral-900/95 text-gray-900 dark:text-gray-200 rounded-lg backdrop-blur-sm">
              {Object.keys(scenarios).map((scenario) => (
                <SelectItem
                  key={scenario}
                  value={scenario}
                  className="text-gray-900 dark:text-gray-200 hover:!bg-orange-300 dark:hover:!bg-orange-500 rounded-lg"
                >
                  {scenario}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Mood Selector */}
        <div className="flex flex-col w-full">
          <label
            className="text-xs md:text-sm font-medium text-gray-900 dark:text-white mb-1"
            htmlFor="response-style"
          >
            Choose Associate's Response Style
          </label>
          <Select
            id="response-style"
            value={selectedMood}
            onValueChange={(val) => setSelectedMood(val)}
          >
            <SelectTrigger className="bg-white/95 dark:bg-gray-800/70 text-gray-900 dark:text-gray-200 border border-gray-300/30 dark:border-orange-500/70 p-2 rounded-lg w-full backdrop-blur-sm hover:bg-orange-500 hover:text-white transition-colors">
              {selectedMood}
            </SelectTrigger>
            <SelectContent className="bg-white dark:bg-neutral-900/95 text-gray-900 dark:text-gray-200 rounded-lg backdrop-blur-sm">
              {Object.keys(moods).map((mood) => {
                return (
                  <Tooltip key={mood}>
                    <TooltipTrigger asChild>
                      <SelectItem
                        value={mood}
                        className="text-gray-900 dark:text-gray-200 hover:!bg-orange-300 dark:hover:!bg-orange-500 rounded-lg"
                      >
                        {mood}
                      </SelectItem>
                    </TooltipTrigger>
                    <TooltipContent side="top" className="max-w-sm">
                      {tooltips[mood]}
                    </TooltipContent>
                  </Tooltip>
                );
              })}
            </SelectContent>
          </Select>
        </div>

        {/* Difficulty Selector */}
        <div className="flex flex-col w-full">
          <label className="text-xs md:text-sm font-medium text-gray-900 dark:text-white mb-1">
            Choose Difficulty Level
          </label>
          <Select value={selectedDifficulty} onValueChange={setSelectedDifficulty}>
            <SelectTrigger className="bg-white/95 dark:bg-gray-800/70 text-gray-900 dark:text-gray-200 border border-gray-300/30 dark:border-orange-500/70 p-2 rounded-lg w-full backdrop-blur-sm hover:bg-orange-500 hover:text-white transition-colors">
              {selectedDifficulty}
            </SelectTrigger>
            <SelectContent className="bg-white dark:bg-neutral-900/95 text-gray-900 dark:text-gray-200 rounded-lg backdrop-blur-sm">
              {Object.keys(difficulties).map((difficulty) => (
                <Tooltip key={difficulty}>
                  <TooltipTrigger asChild>
                    <SelectItem
                      value={difficulty}
                      className="text-gray-900 dark:text-gray-200 hover:!bg-orange-300 dark:hover:!bg-orange-500 rounded-lg"
                    >
                      {difficulty}
                    </SelectItem>
                  </TooltipTrigger>
                  <TooltipContent side="top" className="max-w-sm">
                    {difficulties[difficulty].description}
                  </TooltipContent>
                </Tooltip>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <p className="text-xs 3xl:text-sm text-gray-700 dark:text-gray-300 italic mb-0 3xl:mb-3 text-center">
        Choose a scenario and response style to simulate different coaching challenges.
      </p>

      {/* Descriptions for Scenario & Tone */}
      {selectedScenario && selectedMood && (
        <div className="border border-orange-300/50 dark:border-orange-500/70 bg-white/70 dark:bg-gray-800/60 text-gray-900 dark:text-white p-2 3xl:p-4 rounded-lg mb-2 3xl:mb-4 mt-1 3xl:mt-8 backdrop-blur-sm shadow-md">
          <h2 className="!text-[18px] 3xl:!text-lg font-semibold text-gray-900 dark:text-white">
            Scenario Context:
          </h2>
          <p className="text-sm 3xl:text-sm text-gray-700 dark:text-gray-300 mb-1.5">
            {scenarioDescriptions[selectedScenario]}
          </p>
          <h2 className="!text-[18px] 3xl:!text-lg font-semibold text-gray-900 dark:text-white">
            Response style:
          </h2>
          <p className="text-sm 3xl:text-sm text-gray-700 dark:text-gray-300">
            {moodDescriptions[selectedMood]}
          </p>
        </div>
      )}
    </>
  );
};

export default ScenarioSelector;
